export default __webpack_public_path__ + "static/media/start.753e2e67.svg";